import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ValidatorService } from 'app/core/services/validator.service';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { FlorderFilterComponent, FlorderFilterForm } from 'app/modules/florders/florder-filter/florder-filter.component';
import { BreakpointObserver } from '@angular/cdk/layout';

export interface RelocationFilterForm extends FlorderFilterForm {
  orderTypes: FormControl<string[]>;
  palletIds: FormControl<string[]>;
  transporter: FormControl<string>;
  orderStatuses: FormControl<string[]>;
}

@Component({
  selector: 'app-relocation-filter',
  templateUrl: './relocation-filter.component.html',
  styleUrls: ['../../florders/florder-filter/florder-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class RelocationFilterComponent extends FlorderFilterComponent<RelocationFilterForm> implements OnInit, OnChanges {
  @Output() filterRelocations = new EventEmitter<{ value: FlordersFilter; valid: boolean }>();

  palletIds: Definition[];

  constructor(formBuilder: FormBuilder, validatorService: ValidatorService, breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(formBuilder, validatorService, breakpointObserver, cd);
  }

  protected getControlsConfig() {
    const controlsConfig = super.getControlsConfig();
    Object.assign(controlsConfig, {
      orderTypes: [this.filter.orderTypes],
      palletIds: [this.filter.palletIds],
      transporter: [this.filter.transporter],
      orderStatuses: [this.filter.orderStatuses],
    });
    return controlsConfig;
  }

  filterClicked(): void {
    super.filterClicked(this.filterRelocations);
  }
}
